import { Box, Container, Heading, Stack, Text } from "@chakra-ui/react";
import { MarketingLayout } from "../components/marketing-layout";
import { NewsList } from "../components/newsList";

export const NewsMediaPage = (): JSX.Element => (
	<MarketingLayout>
		<>
			<Box bg="green.800" color="white" py={{ base: "16", md: "24" }}>
				<Container maxW="1560px">
					<Stack spacing="4" maxW="2xl">
						<Heading size={{ base: "xl", md: "3xl" }} fontWeight="extrabold">
							News & Media
						</Heading>
						<Text fontSize={{ base: "md", md: "xl" }} opacity={0.9}>
							Updates, research highlights, and press coverage from Geco.
						</Text>
					</Stack>
				</Container>
			</Box>

			<Box py={{ base: "8", md: "12" }}>
				<Container maxW="1560px">
					<NewsList />
				</Container>
			</Box>
		</>
	</MarketingLayout>
);
